import { RootState } from "../../../../../redux/store";

export const vehicleManufacturersLoading = (state: RootState) => state.vehicleManufacturers.itemsLoading;
export const vehicleManufacturerActionLoading = (state: RootState) => state.vehicleManufacturers.actionsLoading;
export const dropDownLoading = (state: RootState) => state.vehicleManufacturers.dropDownLoading;

export const vehicleManufacturers = (state: RootState) => state.vehicleManufacturers.items;
export const vehicleManufacturersCount = (state: RootState) => state.vehicleManufacturers.itemsCount;
export const vehicleManufacturerForEdit = (state: RootState) => state.vehicleManufacturers.itemForEdit;
export const dropDownValues = (state: RootState) => state.vehicleManufacturers.dropDownItems;

export const error = (state: RootState) => state.vehicleManufacturers.error;
export const errorAction = (state: RootState) => state.vehicleManufacturers.errorAction;
export const dropDownError = (state: RootState) => state.vehicleManufacturers.dropDownError;

export const validationErrors = (state: RootState) => state.vehicleManufacturers.validationErrors;

export const filters = (state: RootState) => state.vehicleManufacturers.filters;
